import React, { useEffect, useState } from "react";
import {
  calculPrixremise,
  calculremisefromval,
} from "../../../_App/Helpers/helpers";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  saveConditionProduitRemiseApi,
  saveRemiseArticleApi,
} from "../../../_App/Redux/Slices/remise/remiseSlice";
import { ToastSuccess } from "../../../Shared/Toasts/ToastSuccess";
import Select from "react-select";
import { number } from "yup";
import { selectUserId } from "../../../_App/Redux/Slices/Auth/authSlice";

export default function RemiseList({
  t,
  articles,
  ListArticle,
  setListArticle,
  listOrganisation,
  societe_id,
  totalItem,
  setselectedOrg,
  selectedOrg,
  Filtre,
}: any) {
  const [option, setOption] = useState("pourcentage");
  const [optionValue, setoptionValue] = useState(0);
  const [qteachetee, setQteachetee] = useState(1);
  const [qtesoldee, setSoldee] = useState(1);

  const [listchecked, setlistchecked] = useState<any[]>([]);
  const [selectiontout, setselectiontout] = useState(0);
  const [inputsCondition, setInputsCondition] = useState({
    qteMin: 1,
    qteMax: 1,
    cumulable: false,
  });
  const userId = useAppSelector(selectUserId);

  // Helper function to get YYYY-MM-DD
  const formatDate = (date: Date) => date.toISOString().split("T")[0];

  const today = new Date();
  const nextYear = new Date();
  nextYear.setFullYear(today.getFullYear() + 1);

  // Initialize state with formatted strings
  const [date_debut, setDate_debut] = useState<string>(formatDate(today));
  const [date_fin, setDate_fin] = useState<string>(formatDate(nextYear));
  const [solde, setSolde] = useState(true);
  const dispatch = useAppDispatch();
  const onchecked = (item: any) => {
    const exists = listchecked.find((a: any) => a._id === item._id);

    let updatedList;

    if (exists) {
      setselectiontout(0);

      updatedList = listchecked.filter((a: any) => a._id !== item._id);
    } else {
      updatedList = [
        ...listchecked,
        { ...item, checked: 1 }, // clone + set checked
      ];
    }

    setlistchecked(updatedList);
  };
  useEffect(() => {
    if (selectiontout === 1) {
      const list = ListArticle.map((a: any) => {
        return { ...a, checked: 1 };
      });

      setlistchecked((prev) => [...prev, ...list]);
    }
  }, [ListArticle]);

  useEffect(() => {
    if (solde) {
      setOption("pourcentage");
    }
  }, [solde]);

  const OnclickAppliquer = () => {
    if (!optionValue || isNaN(optionValue)) {
      ToastWarning("Veuillez entrer une valeur valide.");
      return;
    }
    if (listchecked && listchecked.length === 0) {
      ToastWarning("Veuillez selectionner des articles");
      return;
    }

    const updatedList = listchecked.map((ar: any) => {
      if (ar.checked === 1) {
        if (option === "Valeur") {
          const pourcentage = calculremisefromval(
            ar.prix_vente_ttc,
            optionValue,
          );
          return {
            ...ar,
            newprix: optionValue,
            pourcentage,
          };
        } else {
          const newPrix = calculPrixremise(ar.prix_vente_ttc, optionValue);
          return {
            ...ar,
            newprix: newPrix,
            pourcentage: optionValue,
          };
        }
      } else {
        return {
          ...ar,
          newprix: undefined,
          pourcentage: undefined,
        };
      }
      return { ...ar }; // Clone untouched items too
    });

    setlistchecked(updatedList);
  };
  const OnClickSave = async () => {
    if (listchecked && listchecked.length === 0) {
      ToastWarning("Veuillez selectionner des articles");
      return;
    }
    if (!solde && listchecked.find((a) => !a.newprix)) {
      ToastWarning("Appliquer le remise");
      return;
    }

    const obj = {
      list: listchecked,
      org: selectedOrg.map((org: any) => org.value),
      societe_id: societe_id,
      totalItem,
      optionValue,
      option,
      Filtre,
      selectiontout,
      date_debut,
      date_fin,
      solde,
      qteachetee,
      qtesoldee,
      created_By: userId,
    };
    const resp = await dispatch(saveRemiseArticleApi(obj));
    if (resp.payload.success) {
      ToastSuccess("les remises sont ajoutées");
      setlistchecked([]);
    } else {
      ToastWarning(resp.payload.message);
    }
  };

  const handleOrgChange = (newValue: any) => {
    setselectedOrg(newValue);
  };

  const ChangeConditionChange = (value: any, name: string) => {
    setInputsCondition((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "qteMin") {
      setInputsCondition((prev) => ({
        ...prev,
        qteMax: value,
      }));
    }
  };

  /* const saveCondition = async() => {
    if (listchecked && listchecked.length === 0) {
      ToastWarning("Veuillez selectionner des articles");
      return;
    }
   
    const obj = {
      ...inputsCondition,
      Filtre,
      totalItem,
      selectiontout,
      list: listchecked,
      societe_id: societe_id,
      remise_id,
      type:'Quantité'
    };
     const resp = await dispatch(saveConditionProduitRemiseApi(obj));
    if (resp.payload.success) {
      
      ToastSuccess("la condition est ajoutée");
      console.log('resp.payload.condition',resp.payload.condition)
      setListCondition((prev:any)=>( [...prev , resp.payload.condition]))
        window.scrollTo(0, 0);

      setlistchecked([]);
      
    } else {
      ToastWarning(resp.payload.message);
    }
  };*/
  return (
    <div>
      <div className="mt-3 bg-white" style={{ padding: "10px" }}>
        <div className="row ">
          <div className="col-3">
            <div className="form-group">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Organisation")}
              </label>

              <Select
                isMulti
                options={listOrganisation}
                value={selectedOrg}
                onChange={handleOrgChange}
                placeholder="Sélectionner familles"
              />
            </div>
          </div>
          <div className="col-2">
            <label>{t("Date debut")}</label>
            <input
              type="date"
              className="form-control"
              value={date_debut} // Now a string "YYYY-MM-DD"
              onChange={(e) => setDate_debut(e.target.value)}
            />
          </div>

          <div className="col-2">
            <label>{t("Date fin")}</label>
            <input
              type="date"
              className="form-control"
              value={date_fin} // Now a string "YYYY-MM-DD"
              onChange={(e) => setDate_fin(e.target.value)}
            />
          </div>
          <div className="col-1 mt-3">
            <div className="n-chk">
              <label className="new-control new-radio radio-primary">
                <input
                  id="pourcentage"
                  type="radio"
                  className="new-control-input"
                  checked={solde}
                  onClick={() => setSolde(true)}
                />
                <span className="new-control-indicator"></span>
                {t("Solde")}
              </label>
            </div>

            <div className="n-chk mt-2">
              <label className="new-control new-radio radio-primary">
                <input
                  id="Valeur"
                  type="radio"
                  className="new-control-input"
                  checked={!solde}
                  onClick={() => setSolde(false)}
                />
                <span className="new-control-indicator"></span>
                {t("Remise")}
              </label>
            </div>
          </div>
          <div className="col-1 mt-3">
            <div className="n-chk">
              <label className="new-control new-radio radio-primary">
                <input
                  id="pourcentage"
                  type="radio"
                  className="new-control-input"
                  checked={option === "pourcentage"}
                  onClick={() => setOption("pourcentage")}
                />
                <span className="new-control-indicator"></span>
                {t("pourcentage")}
              </label>
            </div>

            <div className="n-chk mt-2">
              <label className="new-control new-radio radio-primary">
                <input
                  id="Valeur"
                  type="radio"
                  className="new-control-input"
                  checked={option === "Valeur"}
                  disabled={solde}
                  onClick={() => setOption("Valeur")}
                />
                <span className="new-control-indicator"></span>
                {t("Valeur")}
              </label>
            </div>
          </div>
          <div className="col-2">
            <label></label>
            <input
              type="number"
              className=" form-control "
              placeholder={option === "Valeur" ? "Valeur" : "pourcentage"}
              value={optionValue}
              onChange={(e) => setoptionValue(parseFloat(e.target.value))}
            />
          </div>
          {solde && (
            <>
              <div className="col-2">
                <label>{t("quantité achetée")}</label>
                <input
                  type="number"
                  className=" form-control "
                  value={qteachetee}
                  onChange={(e) => setQteachetee(parseFloat(e.target.value))}
                />
              </div>
              <div className="col-2">
                <label>{t("quantité soldée")}</label>
                <input
                  type="number"
                  className=" form-control "
                  value={qtesoldee}
                  onChange={(e) => setSoldee(parseFloat(e.target.value))}
                />
              </div>
            </>
          )}

          {listchecked && listchecked.length !== ListArticle.length && (
            <div className="col-1 mt-3">
              <button
                className="btn "
                onClick={() => {
                  setselectiontout(1);
                  setlistchecked(
                    ListArticle.map((i: any) => {
                      return { ...i, checked: 1 };
                    }),
                  );
                }}
              >
                {t("selectinner tout")}
              </button>
            </div>
          )}
          {listchecked && listchecked.length > 0 && (
            <div className="col-1 mt-3">
              <button
                className="btn "
                onClick={() => {
                  setselectiontout(0);
                  setlistchecked([]);
                }}
              >
                {t("Désélectionner tout")}
              </button>
            </div>
          )}
          {listchecked && listchecked.length > 0 && (
            <>
              {!solde && (
                <div className="col-2">
                  <button
                    className="btn btn-primary w-100"
                    onClick={OnclickAppliquer}
                  >
                    {t("Appliquer")}
                  </button>
                </div>
              )}
              <div className="col-2">
                <button className="btn btn-success w-100" onClick={OnClickSave}>
                  {t("Enregistrer")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="mt-3 bg-white" style={{ padding: "10px" }}>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th></th>
                <th>{t("Famille")}</th>
                <th>{t("Article")}</th>
                <th>{t("Code Article")}</th>
                <th>{t("Prix actuel")}</th>
                <th>{t("Pourcentage remise actuel ")}</th>
                <th>{t("montant remise actuel ")}</th>
                <th>{t("pourcentage nouveau remise")}</th>
                <th>{t("Prix nouveau remise")}</th>
              </tr>
            </thead>
            <tbody>
              {ListArticle &&
                ListArticle.map((a: any) => (
                  <tr key={a._id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          listchecked.find((i) => i._id === a._id)?.checked ===
                          1
                        }
                        onClick={() => onchecked(a)}
                      />
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a.souscategorie?.libelle?.fr}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a?.titre?.fr}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a?.code_article}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a?.prix_vente_ttc}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a?.solde || "-"}%
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {a?.montantsolde || "-"}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {listchecked.find((i) => i._id === a._id)?.pourcentage &&
                        listchecked.find((i) => i._id === a._id)?.pourcentage +
                          "%"}
                    </td>
                    <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      {listchecked.find((i) => i._id === a._id)?.newprix}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
